<template>
    <div>
        <p v-if="isLoading" class="loading-spinner mb-3"><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading...</p>
        <label v-if="heading && heading != ''" class="label mb-3">
            {{ heading }}
            <span v-if="isLoading" class="green"> - updating...</span>
        </label>
        <!-- {{ localChecklist.filter((m) => m.checked).length }} /
              {{ localChecklist.length }} -->
        <draggable
            :key="dragKey"
            :list="localChecklist"
            item-key="id"
            tag="div"
            :disabled="checklistEdited || readOnly"
            @end="updateChecklistOrder()">
            <div v-for="element in localChecklist" :key="element.id" class="fullwidth">
                <div v-if="inputType == 'text'" class="field has-addons mb-2">
                    <p class="control clickable">
                        <a class="button is-static drag-handle">
                            <span class="material-icons-outlined"> drag_handle </span>
                        </a>
                    </p>
                    <p class="control is-expanded">
                        <input
                            :disabled="readOnly"
                            class="input"
                            type="text"
                            v-model="element.text"
                            placeholder="Type a task to be completed.."
                            @input="onChecklistInput(element)" />
                    </p>
                    <p class="control" v-if="!readOnly">
                        <button class="button is-danger" @click="deleteChecklistItem(element.id)">
                            <span class="material-icons-outlined"> delete </span>
                        </button>
                    </p>
                    <p class="control">
                        <button
                            class="button"
                            :disabled="readOnly"
                            :class="[element.checked ? 'is-success' : 'is-dark']"
                            @click="toggleItemChecked(element)">
                            <span class="material-icons-outlined"> {{ element.checked ? 'check_box' : 'check_box_outline_blank' }}</span>
                        </button>
                    </p>
                </div>
                <div v-if="inputType == 'paragraph'" class="field">
                    <div v-if="!readOnly" class="para-wrapper">
                        <textarea
                            :disabled="readOnly"
                            class="textarea"
                            v-model="element.text"
                            placeholder="Type here.."
                            @input="onChecklistInput(element)"></textarea>
                        <div class="buttons" v-if="!readOnly">
                            <button
                                class="button is-danger is-light is-small"
                                @click="
                                    showDeleteItem = true;
                                    selectedItem = element;
                                ">
                                <span class="material-icons-outlined"> delete </span>
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="report-indent box clean mb-3">
                            <p class="report-text">{{ element.text }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="inputType == 'para-para'" class="mb-3">
                    <div class="field" v-if="!readOnly">
                        <div class="side-by-side">
                            <div class="label">Findings</div>
                            <div class="label">Recommendations</div>
                        </div>
                        <div class="para-wrapper">
                            <div class="side-by-side">
                                <div>
                                    <textarea
                                        :disabled="readOnly"
                                        class="textarea"
                                        v-model="element.text"
                                        placeholder="Type here.."
                                        @input="onChecklistInput(element)"></textarea>
                                </div>
                                <div>
                                    <textarea
                                        :disabled="readOnly"
                                        class="textarea"
                                        v-model="element.subtext"
                                        placeholder="Type here.."
                                        @input="onChecklistInput(element)"></textarea>
                                </div>
                            </div>
                            <div class="buttons" v-if="!readOnly">
                                <button
                                    class="button is-danger is-light is-small"
                                    @click="
                                        showDeleteItem = true;
                                        selectedItem = element;
                                    ">
                                    <span class="material-icons-outlined"> delete </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="report-indent box clean">
                            <h5 class="orange">Finding:</h5>
                            <p class="report-text mb-4">{{ element.text }}</p>
                            <!-- <hr /> -->
                            <h5 class="green">Recommendation:</h5>
                            <p class="report-text">{{ element.subtext }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </draggable>

        <div v-if="!readOnly">
            <div v-if="exists" class="field mt-4">
                <div class="buttons">
                    <button class="button is-info" :disabled="checklistEdited" @click="addChecklistItemNew()">
                        <span class="material-icons-outlined"> add </span>
                        <span>{{ addItemButtonText }}</span>
                    </button>
                    <span class="button is-success" :class="{ 'is-loading': isLoading }" v-if="checklistEdited" @click="saveChecklist()">
                        {{ saveButtonText }}
                    </span>
                </div>
            </div>
            <div v-else class="field mt-4">
                <p class="has-text-info">{{ unsavedMessage }}</p>
                <div class="buttons mt-3">
                    <button class="button is-small is-warning" @click="quickSaveParentDoc()">
                        <span class="material-icons-outlined s20"> save </span> &nbsp; Quick Save
                    </button>
                </div>
            </div>
        </div>

        <ConfirmDialog
            v-if="showDeleteItem"
            title="Delete this item?"
            @cancel="showDeleteItem = false"
            theme="is-danger"
            submitText="Yes, Delete"
            @sendResult="confirmDelete($event)">
            <div class="centered">
                <h5 class="red">{{ truncate(selectedItem.text, 100) }}</h5>
                <p>This cannot be undone.</p>
            </div>
        </ConfirmDialog>
    </div>
</template>

<script>
import { db } from '@/main.js';
import draggable from 'vuedraggable';
// import '@vuepic/vue-datepicker/dist/main.css';
import ConfirmDialog from '@/reusables/ConfirmDialog.vue';

// import { currentDataStore } from '@/stores/currentdata';
// import { loggedInUserStore } from '@/stores/userdata';
import { getFirestore, doc, collection, getDocs, addDoc, updateDoc, deleteDoc, query, orderBy, onSnapshot } from 'firebase/firestore';

export default {
    // setup() {
    //     const current_data = currentDataStore();
    //     const user_store = loggedInUserStore();
    //     const db = getFirestore();
    //     return {
    //         current_data: current_data,
    //         user_store: user_store,
    //         db: db
    //     };
    // },

    components: {
        draggable,
        ConfirmDialog
    },

    emits: ['quickSave', 'addItem', 'updateItem', 'deleteItem', 'saveItems', 'reorderItems', 'toggleItem'],

    props: {
        collectionPath: String,
        exists: {
            type: Boolean,
            default: true
        },
        heading: String,
        unsavedMessage: String,
        inputType: {
            type: String,
            default: 'text'
        },
        addItemButtonText: {
            type: String,
            default: 'Add New Item'
        },
        saveButtonText: {
            type: String,
            default: 'Save Checklist'
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: null
        }
    },

    mounted() {
        if (this.items) {
            this.localChecklist = this.items.map((item) => ({ ...item, edited: false }));
        } else {
            this.loadChecklist();
        }
    },

    beforeUnmount() {
        this.checklistUnsubs.forEach((unsub) => unsub());
        this.checklistUnsubs = [];
    },

    computed: {},

    data() {
        return {
            isLoading: false,
            showModal: true,
            editing: false,
            localChecklist: [],
            somethingChanged: false,

            checklistUnsubs: [],
            checklistEdited: false,
            dragLocked: false,
            dragKey: 'drag-unlocked',
            pendingDragLock: false,
            showDeleteItem: false,
            selectedItem: {}
        };
    },

    methods: {
        async loadChecklist() {
            // console.log('Loading checklist for collectionPath', this.collectionPath);
            if (!this.collectionPath || this.collectionPath === '') {
                console.error('collectionPath prop is required for LiveDynamicChecklist');
                return;
            }
            this.isLoading = true;

            this.checklistUnsubs.forEach((unsub) => unsub());
            this.checklistUnsubs = [];

            const collectionRef = collection(db, this.collectionPath);
            const q = query(collectionRef, orderBy('index', 'asc'));
            const unsubscribe = onSnapshot(
                q,
                (snap) => {
                    // reset array each update
                    this.localChecklist = [];

                    snap.forEach((doc) => {
                        this.localChecklist.push({
                            id: doc.id,
                            ...doc.data(),
                            edited: false
                        });
                    });
                },
                (error) => {
                    console.error('checklist snapshot error', error);
                }
            );
            this.checklistUnsubs.push(unsubscribe);
            const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
            await sleep(500);
            this.isLoading = false;
            // console.log('checklist loaded and listener set up', this.collectionPath);
        },

        truncate(string, limit) {
            return string.length > limit ? string.slice(0, limit) + '...' : string;
        },

        quickSaveParentDoc() {
            let result = {
                answer: 'Save outer doc first'
            };
            this.$emit('quickSave', result);
        },

        async saveChecklist() {
            this.isLoading = true;
            if (this.items) {
                this.$emit('saveItems', this.localChecklist);
            } else {
                await Promise.all(
                    this.localChecklist.map(async (item, idx) => {
                        const docRef = doc(db, this.collectionPath, item.id);
                        await updateDoc(docRef, {
                            text: item.text,
                            subtext: item.subtext ?? '',
                            checked: item.checked,
                            index: idx
                        });
                    })
                );
            }
            this.checklistEdited = false;
            this.isLoading = false;
        },

        onChecklistInput(element) {
            this.somethingChanged = true;
            element.edited = true;

            // your existing logic can still flip immediately
            this.checklistEdited = true;

            // but don't remount right now (it will blur)
            this.pendingDragLock = true;
        },

        confirmDelete(result) {
            // console.log('confirmDelete result', result);
            if (result && result.response === true) {
                this.deleteChecklistItem(this.selectedItem.id);
            }
            this.showDeleteItem = false;
        },

        async deleteChecklistItem(id) {
            this.isLoading = true;
            if (this.items) {
                this.localChecklist = this.localChecklist.filter((item) => item.id !== id);
                this.$emit('deleteItem', id);
            } else {
                await deleteDoc(doc(db, this.collectionPath, id));
            }
            this.updateChecklistOrder();
            this.isLoading = false;
            this.somethingChanged = true;
        },

        async addChecklistItemNew() {
            if (this.items) {
                this.$emit('addItem', this.localChecklist.length);
            } else {
                await addDoc(collection(db, this.collectionPath), {
                    text: '',
                    subtext: '',
                    checked: false,
                    edited: false,
                    index: this.localChecklist.length
                });
            }
        },

        async toggleItemChecked(item) {
            if (this.items) {
                item.checked = !item.checked;
                this.$emit('toggleItem', item);
            } else {
                await updateDoc(doc(db, this.collectionPath, item.id), {
                    checked: !item.checked,
                    text: item.text,
                    subtext: item.subtext ?? ''
                });
            }
            this.somethingChanged = true;
        },

        async updateChecklistOrder() {
            if (this.readOnly) return;
            this.isLoading = true;
            if (this.items) {
                this.$emit('reorderItems', this.localChecklist);
            } else {
                await Promise.all(
                    this.localChecklist.map(async (item, idx) => {
                        const docRef = doc(db, this.collectionPath, item.id);
                        await updateDoc(docRef, {
                            index: idx
                        });
                    })
                );
            }
            this.isLoading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.field {
    .control {
        input[type='text'] {
            padding: 7px;
        }
    }
    .para-wrapper {
        position: relative;
        margin-bottom: 12px;
        .buttons {
            position: absolute;
            top: 5px;
            right: 5px;
        }
    }
    .side-by-side {
        display: flex;
        div {
            flex: 1;
            margin-right: 12px;
            &:last-of-type {
                margin-right: 0;
            }
        }
    }
}
.input[disabled] {
    border-color: #dbdbdb;
}
.report-indent {
    margin-left: 5px;
    .report-text {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
}
</style>
